<script lang="ts" context="module">
  export enum GameState {
    Loading,
    Paused,
    Started,
    Over,
  }
</script>
